var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'backbone', 'core', 'view/document', 'app-common/component/loader', 'component/document-uploader', 'app-common/component/api-call', 'app-common/component/inbox-events', 'template/upload/landing.htm', 'template/upload/uploader.htm', 'template/upload/zero-state.htm'], function($, _, Backbone, core, DocumentView, loader, documentUploader, apiCall, inboxEvents, landingTemplate, uploaderTemplate, zerostateTemplate) {
  var UploadBasePage;
  return UploadBasePage = (function(_super) {

    __extends(UploadBasePage, _super);

    function UploadBasePage() {
      UploadBasePage.__super__.constructor.apply(this, arguments);
    }

    UploadBasePage.prototype.pageId = 'upload';

    UploadBasePage.prototype.events = function() {
      return _.extend({}, DocumentView.prototype.events, {
        'keyup .folder-search input': 'expandSearchBar',
        'change .folder-search input': 'expandSearchBar',
        'focus .folder-search input': 'expandSearchBar',
        'blur .folder-search input': 'expandSearchBar',
        'submit .folder-search-form': 'search',
        'click .folder-search-clear': 'clearSearch'
      });
    };

    UploadBasePage.prototype.searchBarMinSize = 75;

    UploadBasePage.prototype.searchBarFocusedMinSize = 150;

    UploadBasePage.prototype.searchBarExpandCoef = 8;

    UploadBasePage.prototype.searchKeyword = null;

    UploadBasePage.prototype.selectedType = 'UNKNOWN';

    UploadBasePage.prototype.filesCreationPromises = [];

    UploadBasePage.prototype.modalDuration = 2500;

    UploadBasePage.prototype.modalAnimationDuration = 700;

    UploadBasePage.prototype.disableDragAndDrop = $.browser.msie;

    UploadBasePage.prototype.isIE9 = $.browser.msie && $.browser.version === '9.0';

    UploadBasePage.prototype.tooltipTemplate = '<div class="tooltip validation-tooltip validation-warning"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>';

    UploadBasePage.prototype.initialize = function(options, params) {
      UploadBasePage.__super__.initialize.apply(this, arguments);
      this.fetchUrl(params);
      return this.render();
    };

    UploadBasePage.prototype.render = function() {
      UploadBasePage.__super__.render.call(this, '');
      loader.init();
      this.loadingPromise = this.loadData(true);
      this.loadingPromise.always(function() {
        return loader.hide();
      });
      return this.initNotifications();
    };

    UploadBasePage.prototype.isZeroState = function() {
      return this.data.results.length === 0 && core.getEarliestDocumentTime() === null;
    };

    UploadBasePage.prototype.refresh = function() {
      if (this.isZeroState()) {
        this.$el.html(_.template(zerostateTemplate));
        return this.initUploader('.zero-state-uploader', _.template(uploaderTemplate, {
          button: '<div class="qq-upload-button">\
                                 <button class="uploader-btn-message btn btn-zerostate ">Upload your first bank statement &rarr;</button>\
                             </div>'
        }));
      } else {
        this.$el.html(_.template(landingTemplate, {
          dropboxEmail: core.getCurrentClient().get('companyEmail'),
          disableDragAndDrop: this.disableDragAndDrop,
          searchKeyword: this.searchKeyword
        }));
        this.refreshTable();
        if (!this.searchKeyword) {
          this.initUploader('.folder__uploader', _.template(uploaderTemplate, {
            button: '<div class="qq-upload-button">\
                                     <div class="uploader-icon ss-upload ss-gizmo"></div>\
                                     <div class="uploader-btn-message">Upload Documents</div>\
                                 </div>'
          }));
        }
        if (core.isCurrentClientBookkeeper()) {
          this.$el.find('.folder-search-inner').show();
          this.expandSearchBar();
        }
        return UploadBasePage.__super__.refresh.apply(this, arguments);
      }
    };

    UploadBasePage.prototype.fetchUrl = function(params) {
      if (params == null) {
        params = [];
      }
      if (params.length === 0) {
        return;
      }
      this.selectedPage = parseInt(params[0]);
      if (params[1]) {
        return this.searchKeyword = core.decodeSearchString(params[1]);
      }
    };

    UploadBasePage.prototype.refreshUrl = function(replace) {
      var params;
      if (replace == null) {
        replace = false;
      }
      params = [];
      if (this.selectedPage !== 1 || this.searchKeyword) {
        params.push(this.selectedPage);
      }
      if (this.searchKeyword) {
        params.push(this.searchKeyword);
      }
      return this.updateUrl(params, replace);
    };

    UploadBasePage.prototype.loadData = function(replaceUrl, showLoader) {
      var params;
      if (replaceUrl == null) {
        replaceUrl = false;
      }
      if (showLoader == null) {
        showLoader = true;
      }
      params = {
        page: this.selectedPage,
        fileName: this.searchKeyword,
        orderBy: 'creationDate'
      };
      return UploadBasePage.__super__.loadData.call(this, replaceUrl, showLoader, params);
    };

    UploadBasePage.prototype.search = function(e) {
      var keyword, searchBar;
      e.preventDefault();
      keyword = this.$el.find('.folder-search input').val();
      if (keyword.length < 3) {
        searchBar = $(e.currentTarget);
        searchBar.tooltip('destroy').tooltip({
          title: 'Please enter at least 3 characters',
          placement: 'in top',
          trigger: 'manual',
          template: this.tooltipTemplate
        }).tooltip('show');
        return setTimeout(function() {
          return searchBar.tooltip('destroy');
        }, 2000);
      } else {
        this.searchKeyword = keyword;
        return this.loadData(true);
      }
    };

    UploadBasePage.prototype.clearSearch = function() {
      this.searchKeyword = null;
      return this.loadData(true);
    };

    UploadBasePage.prototype.notificationSelector = function() {
      return $('.notification-area');
    };

    UploadBasePage.prototype.createFile = function(fileId) {
      var promise,
        _this = this;
      promise = apiCall('document', "fromFile/" + fileId, 'POST');
      this.filesCreationPromises.push(promise);
      return promise.fail(function() {
        if (_this.isZeroState() && !$('.notification-area').length) {
          $('.container-inner').prepend('<div class="notification-area"></div>');
        }
        _this.hideModalUploader();
        return _this.showNotification('process_error', true);
      });
    };

    UploadBasePage.prototype.refreshFilesAfterUploading = function() {
      var promiseCombined, update,
        _this = this;
      update = function() {
        _this.filesCreationPromises = [];
        _this.showFinishedModalUploader();
        return setTimeout(function() {
          _this.fadeOutModalUploader();
          _this.loadData(false, false);
          return setTimeout(function() {
            return _this.hideModalUploader();
          }, _this.modalAnimationDuration);
        }, _this.modalDuration);
      };
      if (this.filesCreationPromises.length === 0) {
        return update();
      } else {
        promiseCombined = $.when.apply($, this.filesCreationPromises);
        return promiseCombined.done(function() {
          return update();
        });
      }
    };

    UploadBasePage.prototype.initUploader = function(container, template) {
      var complete, totalFiles, totalFilesLoaded, totalSize, totalSizesLoaded, uploader,
        _this = this;
      totalFiles = null;
      totalSize = null;
      totalSizesLoaded = [];
      totalFilesLoaded = 0;
      complete = function(success) {
        if (success == null) {
          success = true;
        }
        totalFiles = null;
        totalSize = null;
        totalSizesLoaded = [];
        totalFilesLoaded = 0;
        if (success) {
          _this.refreshFilesAfterUploading();
          if (core.isCurrentClientBookkeeper()) {
            return setTimeout(function() {
              return inboxEvents.updateAndRefreshEventCounters();
            }, 2000);
          }
        } else {
          return _this.hideModalUploader();
        }
      };
      return uploader = documentUploader.initUploader({
        multiple: true,
        params: {
          uploadContext: 'upload',
          clientId: core.getCurrentClientId()
        },
        container: $(container)[0],
        template: template,
        onComplete: function(id, fileName, responseJSON) {
          totalFilesLoaded++;
          _this.createFile(responseJSON.result);
          if (totalFilesLoaded === totalFiles || _this.isIE9) {
            return complete(true);
          }
        },
        onError: function() {
          return complete(false);
        },
        onSubmit: function() {
          return _this.showModalUploader();
        },
        onProgress: function(id, fileName, loaded, total) {
          var files, percentage, totalSizeLoaded;
          files = _.compact(uploader._handler._files);
          if (totalFiles == null) {
            totalFiles = files.length;
          }
          if (totalSize == null) {
            totalSize = _.reduce(files, function(total, file) {
              return total += file.size;
            }, 0);
          }
          totalSizesLoaded[totalFilesLoaded] = loaded;
          totalSizeLoaded = _.reduce(totalSizesLoaded, function(total, size) {
            return total += size;
          }, 0);
          percentage = Math.round(totalSizeLoaded * 100 / totalSize);
          return _this.updateUploaderStats(totalFilesLoaded, totalFiles, percentage);
        }
      });
    };

    UploadBasePage.prototype.initNotifications = function() {
      return this.setNotifications({
        process_error: {
          type: 'error',
          text: 'Sorry, your file could not be processed.'
        }
      });
    };

    UploadBasePage.prototype.showModalUploader = function() {
      this.$el.addClass('modal-uploader-visible');
      this.$el.find('.uploader-modal.drop-and-upload').addClass('hide');
      this.$el.find('.uploader-modal.in-progress').removeClass('hide');
      return this.$el.find('.uploader-modal.finished').addClass('hide');
    };

    UploadBasePage.prototype.showFinishedModalUploader = function() {
      this.$el.find('.uploader-modal.drop-and-upload').addClass('hide');
      this.$el.find('.uploader-modal.in-progress').addClass('hide');
      return this.$el.find('.uploader-modal.finished').removeClass('hide');
    };

    UploadBasePage.prototype.fadeOutModalUploader = function() {
      return this.$el.find('.uploader-modal.finished').addClass('fade');
    };

    UploadBasePage.prototype.hideModalUploader = function() {
      this.$el.find('.uploader-modal.drop-and-upload').removeClass('hide');
      this.$el.find('.uploader-modal.in-progress').addClass('hide');
      this.$el.find('.uploader-modal.finished').addClass('hide').removeClass('fade');
      this.$el.removeClass('modal-uploader-visible');
      return this.updateUploaderStats(null, null, 0);
    };

    UploadBasePage.prototype.updateUploaderStats = function(current, total, percentage) {
      var message;
      message = current === null || total === null ? '' : "" + (current + 1) + " of " + total;
      this.$el.find('.uploader-modal .in-progress-counter').text(message);
      return this.$el.find('.uploader-modal .progress .bar').css('width', percentage + '%');
    };

    UploadBasePage.prototype.isSearchBarFocused = function() {
      return this.$el.find('.folder-search input').is(':focus');
    };

    UploadBasePage.prototype.expandSearchBar = function() {
      var chars, clearButton, minSize, searchBar, size;
      searchBar = this.$el.find('.folder-search input');
      chars = searchBar.val().length;
      minSize = this.isSearchBarFocused() || chars > 0 ? this.searchBarFocusedMinSize : this.searchBarMinSize;
      size = chars * this.searchBarExpandCoef;
      if (size < minSize) {
        size = minSize;
      }
      searchBar.css('width', size + 'px');
      clearButton = this.$el.find('.folder-search-clear');
      if (chars > 0) {
        return clearButton.removeClass('invisible');
      } else {
        return clearButton.addClass('invisible');
      }
    };

    return UploadBasePage;

  })(DocumentView);
});
